import { render, staticRenderFns } from "./CaChip.vue?vue&type=template&id=16cbb840"
import script from "./CaChip.vue?vue&type=script&lang=js"
export * from "./CaChip.vue?vue&type=script&lang=js"
import style0 from "./CaChip.vue?vue&type=style&index=0&id=16cbb840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
